import { theme } from "../../../App";
import makeStyles from "@mui/styles/makeStyles";
const useStyles = makeStyles(() => ({
  ptlMessageContainer: {
    display: "flex",
    "flex-direction": "row",
    "align-items": "flex-start",
    "background-color": "#F1F1F2 !important",
    border: "1px solid #BABBBE !important",
    "border-radius": "4px",
    height: "30px",
    padding: "0",
    gap: "8px",
    // width: 894px;
    width: "100%",
    "margin-bottom": "17px",
    [theme.breakpoints.down("md")]: {
      height: "23px",
    },
  },
  ptlMessageTextContainer: {
    "padding-top": "4px",
    "font-size": "14px",
    color: "#000000",
    [theme.breakpoints.down("md")]: {
      "font-size": "10px",
    },
  },
  ptlMessageIconContainer: {
    "padding-left": "8px",
    "align-items": "center !important",
    [theme.breakpoints.down("md")]: {
      "margin-top": "-3px",
    },
  },
  ptlContainerWidth: {
    width: "111%",

    [theme.breakpoints.up("xl")]: {
      width: "216%",
    },
    [theme.breakpoints.up("lg") && theme.breakpoints.down("xl")]: {
      width: "198%",
    },
    [theme.breakpoints.up("md") && theme.breakpoints.down("lg")]: {
      width: "206%",
    },
    [theme.breakpoints.up("sm") && theme.breakpoints.down("md")]: {
      width: "208%",
    },
  },
  ptlMessageInfoStyle: {
    width: "17px !important",
    height: "26px !important",
    top: "10.5px !important",
    left: "6.5px !important",
    "align-items": "center !important",
    [theme.breakpoints.down("md")]: {
      width: "15px !important",
    },
  },
  ptlMessageContainerWidthForTextField: {
    width: "197%",
    [theme.breakpoints.down("md")]: {
      "font-size": "10px",
    },
    [theme.breakpoints.down("sm")]: {
      "padding-top": "10px",
    },
  },
}));

export default useStyles;
